// extracted by mini-css-extract-plugin
module.exports = {"team":"Team_team__bgm2o","members":"Team_members__3CBL2","data":"Team_data__3hriR","logos_partners":"Team_logos_partners__Wtvhe"};